import MaterialTable from "@material-table/core";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "../../reusable/pagination";
import { useDispatch, useSelector } from "react-redux";
import { changeTabInSidebar } from "../../actions/sidebar";
import { getAllTicketSeries } from "../../actions/ticket";
import { TicketSeriesColumns } from "../../columns/ticketSeriesColumns";
import MagnifyingGlass from "../../common/assets/magnifying-glass.svg";
import { optionsGeneral } from "../../reusable/optionsForTables";
import LoadingIndicator from "../../reusable/loadingIndicator";
import keycloak from "../../keycloak";
import { ROLES } from "../../consts";
import {
  materialTableStyle,
  paginationStyle,
  toolbarStyles,
  useStyles,
  useStylesForMaterial,
} from "../../reusable/styles";
import Sidebar from "../../sidebar/sidebar";
import ModalGenerateTickets from "./ModalGenerateTickets";
import Style from "./ticketSeries.module.css";
import {useAuth} from "react-oidc-context";

export default function TicketSeries() {
  const auth = useAuth();
  const { t } = useTranslation();
  const classes = useStyles();
  const classesMaterial = useStylesForMaterial();
  const classesForm = toolbarStyles();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.loader);
  const { ticketSeries } = useSelector((state) => state.ticketSeries);
  const [openAddGenerateTicketsModal, setOpenAddGenerateTicketsModal] =
    useState(false);

  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setHeight(window.innerHeight);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  const closeModal = () => {
    setOpenAddGenerateTicketsModal(false);
  };
  useEffect(() => {
    dispatch(changeTabInSidebar(4));
  }, [dispatch]);
  useEffect(() => {
    dispatch(getAllTicketSeries());
  }, [dispatch]);

  function toolbar(props) {
    return (
      <div className={classesForm.root}>
        <div className={Style.header}>
          <div className={Style.header__text}>{t("Ticket.TicketSeries")}</div>
          {keycloak.hasRealmRole(ROLES.SYSADMIN, auth) && (
            <button
              className="addEntityButton"
              onClick={() => {
                setOpenAddGenerateTicketsModal(true);
              }}
            >
              <p className={Style.header__addButtonText}>
                {t("Ticket.Generate Tickets")}
              </p>
            </button>
          )}
        </div>
      </div>
    );
  }

  function pagination(props) {
    return (
      <td style={paginationStyle}>
        <Pagination translate={t} {...props} classes={{ ...classesMaterial }} />
      </td>
    );
  }

  return (
    <div className={classes.root}>
      <>
        <Sidebar />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth={false} className={classes.container}>
            {isLoading && <LoadingIndicator />}
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="text-center">
                  <div className="row content">
                    <div className="col-sm-12">
                      <div className={classes.paper}>
                        <MaterialTable
                          style={materialTableStyle}
                          icons={{
                            Filter: () => (
                              <img src={MagnifyingGlass} alt="search" />
                            ),
                          }}
                          title="Ticket series"
                          data={ticketSeries}
                          columns={TicketSeriesColumns(t)}
                          options={optionsGeneral(height - 240, 44)}
                          components={{
                            Toolbar: (props) => toolbar(props),
                            Pagination: (props) => pagination(props),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </main>

        {openAddGenerateTicketsModal && (
          <ModalGenerateTickets
            open={openAddGenerateTicketsModal}
            close={closeModal}
          />
        )}
      </>
    </div>
  );
}
